/**
 * @typedef {Object} AppInfo
 * @property {string} appName - Name of the application
 * @property {string} brand - Brand identifier
 */
/**
 * @type {AppInfo}
 */
export const APP_EVENT_INFO = {
  appName: 'smartgiftDashboard',
  brand: 'smartgift'
};

const TRACKER_EVENT = {
  collectionCreated: 'collectionCreated',
  contactAdded: 'contactAdded',
  contactDeleted: 'contactDeleted',
  contactUpdated: 'contactUpdated',
  contactToService: 'contactToService',
  login: 'login',
  logout: 'logout',
  pageView: 'pageView',
  productAdded: 'productAdded',
  productDetail: 'productDetail',
  productRemoved: 'productRemoved',
  serviceDrafted: 'serviceDrafted',
  serviceInitialized: 'serviceInitialized',
  serviceStarted: 'serviceStarted',
  tagAdded: 'tagAdded',
  tagToContact: 'tagToContact',
  testEmailSent: 'testEmailSent'
};

const CLICKSTREAM_EVENTS = {
  [TRACKER_EVENT.login]: {
    eventType: 'clickstream.customer-identification',
    eventSubType: 'login'
  },
  [TRACKER_EVENT.logout]: {
    eventType: 'clickstream.customer-identification',
    eventSubType: 'logout'
  },
  [TRACKER_EVENT.pageView]: {
    eventType: 'clickstream.pageview',
    eventSubType: 'browse'
  },
  [TRACKER_EVENT.productAdded]: {
    eventType: 'clickstream.add-cart',
    eventSubType: 'browse'
  }
};

const GTM_EVENTS = {
  [TRACKER_EVENT.collectionCreated]: {
    event: 'collection_created'
  },
  [TRACKER_EVENT.contactAdded]: {
    event: 'contact_added'
  },
  [TRACKER_EVENT.contactDeleted]: {
    event: 'contact_deleted'
  },
  [TRACKER_EVENT.contactUpdated]: {
    event: 'contact_updated'
  },
  [TRACKER_EVENT.contactToService]: {
    event: 'contact_to_service'
  },
  [TRACKER_EVENT.login]: {
    event: 'login'
  },
  [TRACKER_EVENT.logout]: {
    event: 'logout'
  },
  [TRACKER_EVENT.pageView]: {
    event: 'page_view'
  },
  [TRACKER_EVENT.productAdded]: {
    event: 'product_added'
  },
  [TRACKER_EVENT.productDetail]: {
    event: 'product_detail'
  },
  [TRACKER_EVENT.productRemoved]: {
    event: 'product_removed'
  },
  [TRACKER_EVENT.serviceDrafted]: {
    event: 'service_drafted'
  },
  [TRACKER_EVENT.serviceInitialized]: {
    event: 'service_initialized'
  },
  [TRACKER_EVENT.serviceStarted]: {
    event: 'service_started'
  },
  [TRACKER_EVENT.tagAdded]: {
    event: 'tag_added'
  },
  [TRACKER_EVENT.tagToContact]: {
    event: 'tag_to_contact'
  },
  [TRACKER_EVENT.testEmailSent]: {
    event: 'test_email_sent'
  }
};

export { CLICKSTREAM_EVENTS, GTM_EVENTS, TRACKER_EVENT };
